import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  PinInput,
  PinInputField,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getSingaltCourse } from "../Redux/Course/action";
import { useNavigate, useParams } from "react-router-dom";
import {
  FaMobileAlt,
  FaLock,
  FaMoneyBillAlt,
  FaUserPlus,
  FaUser,
  FaStar,
  FaBriefcase,
} from "react-icons/fa";
import axios from "axios";

const SingalCourse = () => {
  const toast = useToast();
  const { data, sloading, serror } = useSelector(
    (state) => state.CourseReducer
  );
  const dispatch = useDispatch();
  const [mobile, setmobile] = useState("");
  const [otp, setotp] = useState("");
  const [otpValues, setOtpValues] = useState(["", "", "", "", "", ""]);
  const { id } = useParams();
  const[verified , setverified] = useState("")
  const navigate = useNavigate()
  useEffect(() => {
    dispatch(getSingaltCourse(id));
  }, []);

  const handleOptRequest = () => {
    let obj = {
      countryCode: "+91",
      phoneNumber: mobile,
    };
    axios.post("https://payment-otp.onrender.com/send", obj).then((res) => {
      toast({
        title: res.data.message,
        description: "We've sent you OTP on your mobile",
        status: "success",
        duration: 1000,
        isClosable: true,
        position:"top"
      });
      setotp(res.data.message);
    })
    .catch((err) => {
        console.log(err)
        toast({
          title: "Ploease check your number",
          description: "OTP didt not send at this moment",
          status: "error",
          duration: 1000,
          isClosable: true,
          position:"top"
        });
    })
  };
  const handleOptverify = () => {
    console.log(otpValues.join(""), "fffdfdfdfdf");
    let obj = {
      countryCode: "+91",
      phoneNumber: mobile,
      otp: otpValues.join(""),
    };
    console.log(obj);
    axios
      .post("https://payment-otp.onrender.com/verifysms", obj)
      .then((res) => {
        console.log(res, "verifued opt");
        setverified(res.data.message)
        toast({
          title: res.data.message,
          description: "Now You can enroll for course",
          status: "success",
          duration: 1000,
          isClosable: true,
          position:"top"
        });
      })
      .catch((err) =>{
        console.log(err)
        toast({
          title: "Ploease check your otp",
          description: "OTP that you given is not valid",
          status: "error",
          duration: 1000,
          isClosable: true,
          position:"top"
        });
      });
  };


  const apiKey = process.env.REACT_APP_API_KEY;
  const handleOpenRazorPay = (data)=> {
    const options = {
     "key": apiKey, 
     "amount": Number(data.amount), 
     "currency": "INR",
     "name": "Acme Corp",
     "description": "Test Transaction",
     "image": "https://img.freepik.com/premium-vector/online-payment-concept_118813-2685.jpg?w=2000",
     "order_id": data.id, 
     "handler": function (response){
       axios.post("https://payment-otp.onrender.com/verify", {response})
       .then((res) => {
        console.log(res, "valid")
        toast({
          title: "Payment Completed Successfully",
          description: "You Will Recive Mail For Futher Process",
          status: "success",
          duration: 2000,
          isClosable: true,
          position:"top"
        });
         navigate("/")
       })
       .catch((err) => {
        toast({
          title: "Payment Not Completed Successfully",
          description: "Payment Failed Please check with your bank",
          status: "error",
          duration: 1000,
          isClosable: true,
          position:"top"
        });
       })
   }
    }
 
  const rzp1 = new window.Razorpay(options);
  rzp1.open();
 }
 
   const handlePayment=(amount)=> {
   const   _data = {amount: amount}
      axios.post("https://payment-otp.onrender.com/order", _data)
      .then((res) => handleOpenRazorPay(res.data.data))
      .catch((err) => console.log(err))
   }
  return (
    <Box mt={"100px"} p={8}>
      <Flex align="flex-start">
        <Box flex="1">
          <Heading as="h2" size="lg">
            Government-certified online training
          </Heading>
          <Image
            src={data.image}
            alt="Course"
            mt={4}
            rounded="lg"
            boxShadow="md"
          />
          <Text mt={4} fontWeight="bold" fontSize="xl">
            {data.title}
          </Text>
          <Text mt={2} fontSize="md">
            Master the front-end powerhouse used by Facebook, Netflix,
            Instagram, and more to build seamless applications!
          </Text>
          <Button
            mt={4}
            mr={4}
            size="sm"
            colorScheme="blue"
            fontWeight="bold"
            borderRadius="full"
            leftIcon={<FaStar />}
            _hover={{ transform: "scale(1.05)" }}
          >
            Rating: {data.rating}
          </Button>
          <Button
            mt={2}
            mr={4}
            size="sm"
            colorScheme="blue"
            fontWeight="bold"
            borderRadius="full"
            leftIcon={<FaUser />}
            _hover={{ transform: "scale(1.05)" }}
          >
            4578 Students
          </Button>
          <Button
            mt={2}
            mr={4}
            size="sm"
            colorScheme="blue"
            fontWeight="bold"
            borderRadius="full"
            d
            leftIcon={<FaBriefcase />}
            _hover={{ transform: "scale(1.05)" }}
          >
            Placement Assistance
          </Button>
        </Box>
        <Box flex="1" ml={8}>
          <Card p={4}>
            <FormControl mb={4}>
              <FormLabel fontWeight="bold">Mobile Number</FormLabel>
              <Flex align="center">
                <Box as={FaMobileAlt} color="gray.500" mr={2} />
                <Input
                  onChange={(e) => setmobile(e.target.value)}
                  type="number"
                  placeholder="Enter your mobile number"
                />
              </Flex>
            </FormControl>
            <Button
              colorScheme="blue"
              size="sm"
              fontWeight="bold"
              _hover={{ transform: "scale(1.05)" }}
              onClick={handleOptRequest}
              isDisabled={otp === "OTP send successfully!"}
            >
              Send OTP
            </Button>
            <FormControl>
              <FormLabel>Submit OTP</FormLabel>
              <PinInput size="lg">
                {otpValues.map((value, index) => (
                  <PinInputField
                    key={index}
                    value={value}
                    onChange={(e) => {
                      const newOtpValues = [...otpValues];
                      newOtpValues[index] = e.target.value;
                      setOtpValues(newOtpValues);
                    }}
                  />
                ))}
              </PinInput>
            </FormControl>
            <Button
              colorScheme="blue"
              size="sm"
              fontWeight="bold"
              _hover={{ transform: "scale(1.05)" }}
              onClick={handleOptverify}
              isDisabled={verified=="OTP verified successfully!"}
            >
              Verify OTP
            </Button>
            <FormControl mt={4}>
              <FormLabel fontWeight="bold">Total Fee: {data.price}</FormLabel>
              <Button
                colorScheme="blue"
                size="md"
                fontWeight="bold"
                _hover={{ transform: "scale(1.05)" }}
                isDisabled={verified!=="OTP verified successfully!"}
                onClick={() => handlePayment(data.price)}
              >
                Enroll Now
              </Button>
            </FormControl>
          </Card>
        </Box>
      </Flex>
    </Box>
  );
};

export default SingalCourse;
